$('.product-quantity-section, .quantity').each(function () {
    const $quantity = $(this);
    const $input = $quantity.find('.qty');

    function normalizeQuantity() {
        let value = $input.val();

        value = String(value).replace(/[^0-9]/g, '');
        value = value.replace(/^0+/, '');

        let quantity = parseInt(value, 10);

        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }

        if (quantity > 99) {
            quantity = 99;
        }

        $input.val(quantity);

        return quantity;
    }

    function updateQuantity() {
        normalizeQuantity();

        $input.trigger('change');
    }

    $quantity.find('.product-quantity-minus').on('click', function () {
        const quantity = parseInt($input.val(), 10) || 1;

        if (quantity > 1) {
            $input.val(quantity - 1);
            updateQuantity();
        }
    });

    $quantity.find('.product-quantity-plus').on('click', function () {
        const quantity = parseInt($input.val(), 10) || 1;

        if (quantity < 99) {
            $input.val(quantity + 1);
            updateQuantity();
        }
    });

    $input.on('input', function () {
        let value = $(this).val();

        value = String(value).replace(/[^0-9]/g, '');

        if (value.length > 2) {
            value = value.substring(0, 2);
        }

        $(this).val(value);
    });

    $input.on('change', function () {
        normalizeQuantity();
    });

    $input.on('blur', function () {
        updateQuantity();
    });

    $input.on('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            updateQuantity();

            $(this).blur();
        }
    });
});